module.exports = __webpack_public_path__ + "static/media/salad.d782d052.svg";